.kbd {
  font-family: var(--font-sans);
  font-size: 11px;
  font-weight: var(--font-weight-medium);
  line-height: 18px;
  color: var(--text-subtle);
  border: 1px solid var(--border);
  border-radius: var(--radius-small);
  padding: 0 var(--space-1);
  background: var(--surface-sunken);
}
